(function(){
  // ------------- UTILITIES -------------
  function qs(sel, root){ return (root||document).querySelector(sel); }
  function qsa(sel, root){ return Array.from((root||document).querySelectorAll(sel)); }
  function safeGetLS(key){
    try { return localStorage.getItem(key); } catch(e){ return null; }
  }
  function safeSetLS(key, val){
    try { localStorage.setItem(key, val); } catch(e){}
  }
  function normalizePhoneIN(input){
  if (!input) return '';
  const digits = String(input).replace(/\D/g, '');

  // Common cases:
  // 10 digits: 9811843355
  // 11 digits starting with 0: 09811843355
  // 12 digits starting with 91: 919811843355
  // 13 digits starting with 0 + 91: 0919811843355

  let d = digits;

  if (d.length === 11 && d.startsWith('0')) d = d.slice(1);
  if (d.length === 13 && d.startsWith('091')) d = d.slice(1);

  if (d.length === 12 && d.startsWith('91')) return '+' + d;
  if (d.length === 10) return '+91' + d;

  // Fallback: return digits only, but Shopify may still reject if length is wrong
  return d ? '+' + d : '';
}

  function buildParams(addr, email){
    const p = new URLSearchParams();
    if (email) p.set('checkout[email]', email);
    if (addr.phone) p.set('checkout[phone]', addr.phone);
    if (addr.phone) p.set('checkout[shipping_address][phone]', addr.phone);
    p.set('checkout[shipping_address][first_name]', addr.first_name || '');
    p.set('checkout[shipping_address][last_name]',  addr.last_name  || '');
    p.set('checkout[shipping_address][address1]',   addr.address1   || '');
    if (addr.address2) p.set('checkout[shipping_address][address2]', addr.address2);
    p.set('checkout[shipping_address][city]',       addr.city       || '');
    p.set('checkout[shipping_address][zip]',        addr.zip        || '');
    if (addr.province_code) p.set('checkout[shipping_address][province_code]', addr.province_code);
    if (addr.province)      p.set('checkout[shipping_address][province]',      addr.province);
    if (addr.country_code)  p.set('checkout[shipping_address][country_code]',  addr.country_code);
    if (addr.country)       p.set('checkout[shipping_address][country]',       addr.country);
    return p;
  }
  function fillHiddenForm(addr, email){
    const form = qs('#why-prefill-checkout');
    if (!form) return false;
    function fill(name, val){
      const el = form.querySelector(`[name="${CSS.escape(name)}"]`);
      if (el) el.value = val || '';
    }
    fill('checkout[email]', email || '');
    fill('checkout[phone]', addr.phone || '');
    fill('checkout[shipping_address][phone]', addr.phone || '');
    fill('checkout[shipping_address][first_name]', addr.first_name || '');
    fill('checkout[shipping_address][last_name]',  addr.last_name  || '');
    fill('checkout[shipping_address][address1]',   addr.address1   || '');
    fill('checkout[shipping_address][address2]',   addr.address2   || '');
    fill('checkout[shipping_address][city]',       addr.city       || '');
    fill('checkout[shipping_address][zip]',        addr.zip        || '');
    fill('checkout[shipping_address][province]',       addr.province || '');
    fill('checkout[shipping_address][province_code]', addr.province_code || '');
    fill('checkout[shipping_address][country]',        addr.country || '');
    fill('checkout[shipping_address][country_code]',   addr.country_code || '');
    return true;
  }

  // ------------- 1) CAPTURE SELECTION FROM YOUR WIDGET -------------
  // Delegated click so it works even if widget is re-rendered via AJAX
  document.addEventListener('click', function(e){
    const btn = e.target.closest('.why-address-item');
    if (!btn) return;

    // toggle pressed state
    const list = btn.closest('.why-list') || document;
    qsa('.why-address-item[aria-pressed="true"]', list).forEach(b => b.setAttribute('aria-pressed', 'false'));
    btn.setAttribute('aria-pressed', 'true');

    const payload = {
      first_name:   btn.dataset.first || '',
      last_name:    btn.dataset.last || '',
      phone:        normalizePhoneIN(btn.dataset.phone || ''),
      address1:     btn.dataset.address1 || '',
      address2:     btn.dataset.address2 || '',
      city:         btn.dataset.city || '',
      zip:          btn.dataset.zip || '',
      country:      btn.dataset.country || '',
      country_code: btn.dataset.countryCode || '',
      province:     btn.dataset.province || '',
      province_code:btn.dataset.provinceCode || '',
      customer_address_id: btn.dataset.id || ''
    };
    safeSetLS('why_checkout_shipto', JSON.stringify(payload));

    // mirror selection into the banner line for immediate feedback
    const banner = qs('#why-address-banner');
    if (banner){
      const line = banner.querySelector('[data-line="area"]');
      if (line) line.textContent = `${payload.city || ''} ${payload.zip || ''}`.trim();
    }
  });

  // ------------- 2) INTERCEPT CHECKOUT CLICKS -------------
  // Covers cart page, drawer, mini-cart, any button/link that leads to checkout
  const CHECKOUT_SELECTOR = [
    'button[name="checkout"]',
    '#checkout',
    '.cart__checkout-button',
    'a[href$="/checkout"]',
    'button[data-testid="Checkout-button"]' // some apps/themes
  ].join(',');

  function getCustomerEmail(){
    const root = qs('#why-address-banner');
    return root && root.dataset.customerEmail ? root.dataset.customerEmail : '';
  }

  function selectedAddress(){
    const raw = safeGetLS('why_checkout_shipto');
    if (!raw) return null;
    try { return JSON.parse(raw); } catch(e){ return null; }
  }

  function hasMinimalAddress(a){
    return !!(a && a.address1 && a.city && a.zip);
  }

  function interceptHandler(ev){
    const a = selectedAddress();
    if (!hasMinimalAddress(a)) return; // let normal flow through
    // Important: prevent default to avoid the theme’s native navigation first
    ev.preventDefault();
    ev.stopPropagation();

    // Prefer POST (hidden form) which is most reliable with long addresses
    const ok = fillHiddenForm(a, getCustomerEmail());
    if (ok) {
      qs('#why-prefill-checkout').submit();
      return;
    }

    // Fallback to querystring navigation
    const q = buildParams(a, getCustomerEmail());
    // Avoid /cart/checkout; jump straight to /checkout
    window.location.href = '/checkout?' + q.toString();
  }

  function attachInterceptors(root){
    qsa(CHECKOUT_SELECTOR, root).forEach(btn => {
      // avoid double-binding
      if (btn.dataset.whyCheckoutBound) return;
      btn.dataset.whyCheckoutBound = '1';
      btn.addEventListener('click', interceptHandler, {capture:true});
    });
  }

  // Initial bind
  document.addEventListener('DOMContentLoaded', function(){
    attachInterceptors(document);
  });

  // Re-bind after AJAX section renders (Dawn cart drawer, etc.)
  const mo = new MutationObserver(muts => {
    muts.forEach(m => {
      if (m.addedNodes && m.addedNodes.length){
        m.addedNodes.forEach(node => {
          if (!(node instanceof HTMLElement)) return;
          attachInterceptors(node);
        });
      }
    });
  });
  mo.observe(document.documentElement, { childList: true, subtree: true });

  // ------------- 3) OPTIONAL: STORE THE CHOSEN ID IN CART ATTRIBUTES -------------
  // analytics only, does not affect shipping address
  function syncCartAttribute(){
    const a = selectedAddress();
    if (!a || !a.customer_address_id) return;
    fetch('/cart/update.js', {
      method:'POST',
      headers:{'Content-Type':'application/json'},
      body: JSON.stringify({ attributes: { SelectedAddressId: a.customer_address_id }})
    }).catch(()=>{});
  }
  // run on selection and periodically
  document.addEventListener('click', function(e){
    if (e.target.closest('.why-address-item')) syncCartAttribute();
  });
})();
